import apiClient from "./client";

// fetch list of ZoneDto
export function getAll() {
  return apiClient.get("/findings").then((res) => res.data);
}

export function getFindingByStatus(statusId) {
  return apiClient.get(`/findings/status/${encodeURIComponent(statusId)}`).then((res) => res.data);
}

export function getAllByInspectionId(inspectionId) {
  return apiClient
    .get(`/findings/byInspection/${encodeURIComponent(inspectionId)}`)
    .then((res) => res.data);
}

export function getById(id) {
  return apiClient.get(`/findings/${encodeURIComponent(id)}`).then((res) => res.data);
}

export function createFinding(data) {
  return apiClient.post("/findings", data).then((res) => {
    // CreatedAtRoute returns the full FindingDto, extract the findingId
    return res.data?.findingId || res.data;
  });
}

export function submitFormResponse(formId, responsePayload) {
  return apiClient
    .post(`/findings/${encodeURIComponent(formId)}/responses`, responsePayload)
    .then((r) => r.data);
}

export function deleteItem(id) {
  return apiClient.delete(`/findings/${encodeURIComponent(id)}`).then((res) => {
    // DELETE typically returns 204 No Content, so no data to return
    return res;
  });
}

//export function updateFinding(id, data) {
//  return apiClient.put(`/findings/${encodeURIComponent(id)}`, data).then((res) => res.data);
//}

export function updateFinding(id, dto, updateType = 1) {
  return apiClient.put(`/findings/${encodeURIComponent(id)}`, dto, { params: { updateType } });
}

export function exportFindingsToExcel() {
  return apiClient.post("/findings/export/excel", {}, { responseType: 'blob' });
}
